<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          Add Room Notification
        </v-card-title>

        <v-card-text>
          <v-row>
            <!-- Room Dropdown -->
            <v-col sm="4">
              <v-select
                v-model="form.room_id"
                :items="rooms"
                item-text="name"
                item-value="id"
                outlined
                label="Select Room"
                prepend-inner-icon="mdi-door"
                :loading="roomLoading"
              />
            </v-col>

            <!-- Title -->
            <v-col sm="4">
              <v-text-field
                v-model="form.title"
                outlined
                label="Title"
                prepend-inner-icon="mdi-bell-ring-outline"
              />
            </v-col>

            <!-- Message -->
            <v-col sm="8">
              <v-textarea
                v-model="form.message"
                outlined
                label="Notification Message"
                prepend-inner-icon="mdi-message-text-outline"
              />
            </v-col>
          </v-row>

          <v-divider class="my-5" />

          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Notification
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "RoomNotificationCreate",
  data() {
    return {
      form: {
        room_id: null,
        title: "",
        message: "",
      },
      isLoading: false,
      roomLoading: false,
      rooms: [],
    };
  },
  mounted() {
    this.getRooms();
  },
  methods: {
    async getRooms() {
      this.roomLoading = true;
      try {
        const res = await axios.get("/rooms");
        this.rooms = res.data.data || res.data; // depending on your API response
      } catch (err) {
        console.error("Failed to fetch rooms", err);
      } finally {
        this.roomLoading = false;
      }
    },

    async save() {
      try {
        this.isLoading = true;

        await axios.post("/room_notifications", this.form);
        this.isLoading = false;

        this.$router.back(); // or use this.$router.push('/room-notifications')
      } catch (err) {
        console.error("Failed to save notification", err);
        this.isLoading = false;
      }
    },
  },
};
</script>
